import React, { useState } from '../../../../_snowpack/pkg/react.js';
import { Card, Icon } from '../../../css/index.js';
import { PieChart } from '../../../../_snowpack/pkg/react-minimal-pie-chart.js';
import Slider from './slider.js';
import { NotAWizard, ProgressWrapper, ProgressGroup, ProgressAnchor, ProgressChart, ProgressLabel, CheckMark } from './styles.js';
const pieSettings = {
  radius: 35,
  lineWidth: 18
};
const cf = '#C2E5E1';
const cu = '#E2E2E2';

const Wizard = ({
  tenant,
  pipeline
}) => {
  var _pipeline$getMany, _t$metrics, _t$metrics$items, _t$metrics2, _t$metrics2$items, _t$grids, _t$topics, _t$shapes, _t$metrics3, _t$metrics3$apiCalls, _t$webhooks, _t$metrics4, _t$metrics4$orders;

  const t = tenant === null || tenant === void 0 ? void 0 : tenant.get;
  const p = pipeline === null || pipeline === void 0 ? void 0 : (_pipeline$getMany = pipeline.getMany) === null || _pipeline$getMany === void 0 ? void 0 : _pipeline$getMany.edges;
  const productCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$metrics = t.metrics) === null || _t$metrics === void 0 ? void 0 : (_t$metrics$items = _t$metrics.items) === null || _t$metrics$items === void 0 ? void 0 : _t$metrics$items.products);
  const documentCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$metrics2 = t.metrics) === null || _t$metrics2 === void 0 ? void 0 : (_t$metrics2$items = _t$metrics2.items) === null || _t$metrics2$items === void 0 ? void 0 : _t$metrics2$items.documents);
  const gridCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$grids = t.grids) === null || _t$grids === void 0 ? void 0 : _t$grids.length);
  const topicCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$topics = t.topics) === null || _t$topics === void 0 ? void 0 : _t$topics.length);
  const shapeCompleted = t === null || t === void 0 ? void 0 : (_t$shapes = t.shapes) === null || _t$shapes === void 0 ? void 0 : _t$shapes.some( // check if any shape has created or edited after the tenant has created
  ({
    createdAt,
    updatedAt
  }) => new Date(updatedAt !== null && updatedAt !== void 0 ? updatedAt : createdAt).getTime() - new Date(t.createdAt).getTime() > 1000);
  const apiCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$metrics3 = t.metrics) === null || _t$metrics3 === void 0 ? void 0 : (_t$metrics3$apiCalls = _t$metrics3.apiCalls) === null || _t$metrics3$apiCalls === void 0 ? void 0 : _t$metrics3$apiCalls.count);
  const hookCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$webhooks = t.webhooks) === null || _t$webhooks === void 0 ? void 0 : _t$webhooks.length);
  const orderCompleted = Boolean(t === null || t === void 0 ? void 0 : (_t$metrics4 = t.metrics) === null || _t$metrics4 === void 0 ? void 0 : (_t$metrics4$orders = _t$metrics4.orders) === null || _t$metrics4$orders === void 0 ? void 0 : _t$metrics4$orders.count);
  const fulfilmentCompleted = Boolean(p === null || p === void 0 ? void 0 : p.length);
  const progress = {
    create: {
      product: {
        value: 25,
        color: productCompleted ? cf : cu,
        completed: productCompleted >= 1,
        index: 0,
        icon: /*#__PURE__*/React.createElement(Icon.Product, {
          size: 20,
          outline: !productCompleted,
          color: "green"
        }),
        title: productCompleted ? 'Product created' : 'Create a product'
      },
      document: {
        value: 25,
        color: documentCompleted ? cf : cu,
        completed: documentCompleted,
        index: 1,
        icon: /*#__PURE__*/React.createElement(Icon.Document, {
          size: 19,
          outline: !documentCompleted,
          color: "green"
        }),
        title: documentCompleted ? 'Document created' : 'Create a document'
      },
      grid: {
        value: 25,
        color: gridCompleted ? cf : cu,
        completed: gridCompleted,
        index: 2,
        icon: /*#__PURE__*/React.createElement(Icon.Grid, {
          color: "green",
          size: 19,
          outline: !gridCompleted
        }),
        title: gridCompleted ? 'Grid created' : 'Create a grid'
      },
      topic: {
        value: 25,
        color: topicCompleted ? cf : cu,
        completed: topicCompleted,
        index: 3,
        icon: /*#__PURE__*/React.createElement(Icon.Topics, {
          color: "green",
          size: 22,
          outline: !topicCompleted
        }),
        title: topicCompleted ? 'Topic created' : 'Create a topic'
      }
    },
    build: {
      shape: {
        value: 25,
        color: shapeCompleted ? cf : cu,
        completed: shapeCompleted,
        index: 4,
        icon: /*#__PURE__*/React.createElement(Icon.Shapes, {
          size: 22,
          outline: !shapeCompleted
        }),
        title: shapeCompleted ? 'Shape created' : 'Create a shape'
      },
      api: {
        value: 25,
        color: apiCompleted ? cf : cu,
        completed: apiCompleted,
        index: 5,
        icon: /*#__PURE__*/React.createElement(Icon.GraphQL, {
          size: 22,
          outline: !apiCompleted
        }),
        title: apiCompleted ? 'Api call made' : 'Make a api call'
      },
      webhook: {
        value: 25,
        color: hookCompleted ? cf : cu,
        completed: hookCompleted,
        index: 6,
        icon: /*#__PURE__*/React.createElement(Icon.Hooks, {
          color: "green",
          size: 22,
          outline: !hookCompleted
        }),
        title: hookCompleted ? 'Webhook created' : 'Create a webhook'
      }
    },
    manage: {
      order: {
        value: 50,
        color: orderCompleted ? cf : cu,
        completed: orderCompleted,
        index: 7,
        icon: /*#__PURE__*/React.createElement(Icon.Order, {
          size: 22,
          color: "green",
          outline: !orderCompleted
        }),
        title: orderCompleted ? 'Order received' : 'Receive order'
      },
      fulfilment: {
        value: 50,
        color: fulfilmentCompleted ? cf : cu,
        completed: fulfilmentCompleted,
        index: 8,
        icon: /*#__PURE__*/React.createElement(Icon.Fulfilment, {
          size: 22,
          outline: !fulfilmentCompleted
        }),
        title: fulfilmentCompleted ? 'Order managed' : 'Manage an order'
      }
    }
  };

  const findCurrentStep = obj => {
    for (const parentKey in obj) {
      for (const childKey in obj[parentKey]) {
        if (!obj[parentKey][childKey].completed) {
          return obj[parentKey][childKey].index;
        }
      }
    }

    return 0;
  };

  const [[page, direction], setPage] = useState([findCurrentStep(progress), 0]);

  const paginate = newDirection => {
    if (newDirection < 0 && page === 0) {
      setPage([0, 0]);
      return;
    }

    if (newDirection > 0 && page === 8) {
      setPage([8, 0]);
      return;
    }

    setPage([page + newDirection, newDirection]);
  };

  return /*#__PURE__*/React.createElement(NotAWizard, null, /*#__PURE__*/React.createElement(Slider, {
    page: page,
    setPage: setPage,
    direction: direction,
    paginate: paginate,
    progress: progress
  }), /*#__PURE__*/React.createElement(ProgressWrapper, null, Object.keys(progress).map(parentKey => {
    const parentObj = progress[parentKey];
    return /*#__PURE__*/React.createElement(Card, {
      cssShadow: true,
      borderRadius: 8,
      style: {
        height: '100%'
      },
      key: `${parentKey}-progress-card`
    }, /*#__PURE__*/React.createElement(ProgressGroup, null, /*#__PURE__*/React.createElement(ProgressChart, null, /*#__PURE__*/React.createElement(ProgressLabel, null, /*#__PURE__*/React.createElement("span", null, Object.keys(parentObj).map(key => parentObj[key]).filter(f => !!f.completed).length, "/", Object.keys(parentObj).map(key => parentObj[key]).length), parentKey), /*#__PURE__*/React.createElement(PieChart, {
      radius: pieSettings.radius,
      data: Object.keys(parentObj).map(key => parentObj[key]),
      lineWidth: pieSettings.lineWidth,
      paddingAngle: 5
    })), /*#__PURE__*/React.createElement("div", null, Object.keys(parentObj).map(key => {
      const obj = parentObj[key];
      return /*#__PURE__*/React.createElement(ProgressAnchor, {
        isCompleted: obj.completed,
        onClick: () => setPage([obj.index, 0]),
        active: page === obj.index,
        key: obj.index
      }, /*#__PURE__*/React.createElement(CheckMark, {
        isCompleted: obj.completed
      }, obj.completed && /*#__PURE__*/React.createElement("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 27 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M1.34625 21.5251L10.3268 27.0874C10.9681 27.6769 11.7671 28 12.5845 28C12.7763 28 12.9693 27.9822 13.1558 27.9474C14.1807 27.7574 15.0906 27.0654 15.6539 26.0475L26.4135 6.5902C26.9433 5.63206 27.1224 4.48953 26.9171 3.37408C26.7119 2.25864 26.1473 1.30338 25.3282 0.684082C24.7356 0.23636 24.0504 0 23.3476 0C22.1004 0 20.9518 0.729627 20.2757 1.95252L11.6338 17.5794L5.88535 14.8316C5.24767 14.2564 4.45906 13.9418 3.65387 13.9418C2.54916 13.9418 1.51499 14.5162 0.818868 15.5172C-0.45335 17.343 -0.21709 20.0388 1.34625 21.5251Z",
        fill: "#DAF0ED"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2757 1.95252L11.6338 17.5794L5.88535 14.8316C5.24767 14.2564 4.45906 13.9418 3.65387 13.9418C2.54916 13.9418 1.51499 14.5162 0.818868 15.5172C-0.45335 17.343 -0.21709 20.0388 1.34625 21.5251L10.3268 27.0874C10.9681 27.6769 11.7671 28 12.5845 28C12.7763 28 12.9693 27.9822 13.1558 27.9474C14.1807 27.7574 15.0906 27.0654 15.6539 26.0475L26.4135 6.5902C26.9433 5.63206 27.1224 4.48953 26.9171 3.37408C26.7119 2.25864 26.1473 1.30338 25.3282 0.684082C24.7356 0.23636 24.0504 0 23.3476 0C22.1004 0 20.9518 0.729627 20.2757 1.95252ZM24.7251 1.48178C24.296 1.15766 23.8204 1 23.3476 1C22.5142 1 21.6764 1.48566 21.1508 2.43636L12.0529 18.888L5.32324 15.6713L5.21555 15.5742C4.74811 15.1526 4.19404 14.9418 3.65387 14.9418C2.91409 14.9418 2.17155 15.3236 1.63984 16.0881C0.655829 17.5003 0.83928 19.5877 1.96712 20.7334L10.9338 26.2871L11.0035 26.3512C11.4736 26.7833 12.0354 27 12.5845 27C12.7153 27 12.8469 26.9878 12.9722 26.9644L12.9735 26.9641C13.6681 26.8354 14.3414 26.354 14.779 25.5633L25.5384 6.10628C25.9521 5.35821 26.0986 4.45174 25.9336 3.55505C25.7686 2.65808 25.3235 1.93423 24.7251 1.48178Z",
        fill: "#828A90"
      }))), /*#__PURE__*/React.createElement("span", {
        "data-cypress": "dashboard-item"
      }, obj.title));
    }))));
  })));
};

export default Wizard;